import React from 'react'
import styles from "./categories.module.scss"
import { ERCText } from 'components/text'


const CategoriesStack = ({img, categoryName, onClick}) => {
  return (
        <div className={styles.categories_container} onClick={onClick}>
         <div className={styles.categories_content}>
            <img width="40px" height="36px" src={img} alt="img" />
            <ERCText lHeight='20px'  styles="normal" weight='600'  size='16px'  >{categoryName}</ERCText>
         </div>
        </div>
  )
}

export default CategoriesStack
